import facilityContractTemplate from '@/views/person-center/project/contract-comp/facility-contract-template/facility-contract-template.vue';
import ProjectService from '@/views/person-center/project/project.service.js';
import Service from '@/service/index.js';
// import RegExpObj from '@/utils/regExp.js';
import { successMessage, errorMessage } from '@/utils/message.js';
export default {
  components: {
    facilityContractTemplate
  },
  data() {
    var oninput = (rule, value, callback) => {
      if(value === '' || value === null){
        callback(new Error('请输入1-1000的整数'));
      } else if(value < 1 || value > 1000){
        callback(new Error('请输入1-1000'));
      } else {
        callback();
      }
    };
    const installmentSumTermValidator = (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入分期付款的期数'));
      } else if(value <= 1 || value > 100){
        return callback(new Error('1-100'));
      } else {
        callback();
      }
    };
    const installmentPerYearValidator =  (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入每期多少年'));
      } else if(value <= 1 || value > 10){
        return callback(new Error('1-10'));
      } else {
        callback();
      }
    };
    const afterYearsPayNextPriceValidator =  (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入'));
      } else if(value <= 0 || value > 10){
        return callback(new Error('1-10'));
      } else if(!this.ruleForm.afterDatePayNextPrice) {
        return callback(new Error('请选择日期'));
      } else {
        callback();
      }
    };
    const installmentPerYearPriceAddPercentValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入每期承包费递增百分比'));
      } else if(value < 0 || value > 100){
        return callback(new Error('0-100'));
      } else {
        callback();
      }
    };
    return {
      // 设置只能选择当前日期及之后的日期
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      projectSubType: '',
      checked: true,
      checked1: false,
      ruleForm: {
        sumCurrentPrice: '',
        remainMoney: 0,
        lastPayDate: '', // 剩余交付日期
        inKindOrOtherMethod: '',
        otherMethod: '',
        projectDeposit: '', // 项目定金
        contractDeposit: '',
        payType: 1,
        paymentContractDepositAgreedDay: '', // 支付合同定金约定
        refundContractDepositAgreedDay: '', // 返还合同定金约定
        lastDeliverDate: '', // 最晚交付日期
        resolveDisputesWays: '', // 解决争议途径
        agreedTaxTreatment: '',
        // useBidMatterExpensesAgreement: '',
        afterDatePayNextPrice: '',
        otherAgreement: '',
        partyaOverdueProportion: '', // 甲方逾期违约金比例
        partyaOverdueDate: '', // 乙方逾期违约金比例
        partybOverdueProportion: '', // 乙方逾期违约金比例
        partybOverdueDate: '', // 乙方逾期超时日
        // remainingPriceOfFirstInstallment: '',
        contractEffectivePeriod: '',
        remainingContractInstallmentDescription: '',
        contractFeePerYear: '', // 每年租金
        installmentSumTerm: '', // 共分为
        afterYearsPayNextPrice: '', // 以后每
        installmentPerYear: '', // 每期多少年
        installmentPerYearPriceAddPercent: '', // 每期租金递增
        installmentPriceOfFirst: '', // 第一期价款金额
        remainingPriceOfFirstInstallment: '', // 第一期价款剩余金额
        installmentPriceOfFirstExList: [
          {
            amount: '',
            payDate: ''
          }
        ]
      },
      projectDepositList: [
        {code: 1, 'value': '需要定金'},
        {code: 2, 'value': '不需要定金'}
      ],
      useBidList: [
        {code: 1, 'value': '甲方承担'},
        {code: 2, 'value': '乙方承担'}
      ],
      rules: {
        lastPayDate: [
          { required: true, message: '请选择剩余交付日期', trigger: 'blur' }
        ],
        inKindOrOtherMethod: [
          { required: true, message: '请输入以实物或者实物折资方式', trigger: 'blur' }
        ],
        projectDeposit: [
          { required: true, message: '请选择是否需要项目定金', trigger: 'change' }
        ],
        contractDeposit: [
          { required: true, message: '请输入合同定金', trigger: 'blur' }
        ],
        paymentContractDepositAgreedDay: [
          { required: true, message: '请输入支付合同定金约定日', trigger: 'blur' }
        ],
        refundContractDepositAgreedDay: [
          { required: true, message: '请输入返还合同定金约定日', trigger: 'blur' }
        ],
        lastDeliverDate: [
          { required: true, message: '请选择最晚交付日期', trigger: 'blur' }
        ],
        resolveDisputesWays: [
          { required: true, message: '请选择解决争议途径', trigger: 'blur' }
        ],
        // useBidMatterExpensesAgreement: [
        //   { required: true, message: '请选择使用标的发生费用约定', trigger: 'change' }
        // ],
        partyaOverdueProportion: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        partyaOverdueDate: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        partybOverdueProportion: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        partybOverdueDate: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        agreedTaxTreatment: [
          { required: true, message: '请输入约定税费处理方式', trigger: 'blur' }
        ],
        contractEffectivePeriod: [
          { required: true, message: '请输入合同生效后多少天支付第一期剩余价款', trigger: 'blur' }
        ],
        remainingContractInstallmentDescription: [
          { required: true, message: '请输入剩余合同分期描述', trigger: 'blur' }
        ],
        contractFeePerYear: [
          { required: true, message: '请输入每年租金', trigger: 'blur' }
        ],

        installmentSumTerm: [
          { required: true, validator: installmentSumTermValidator, trigger: 'blur' }
        ],
        installmentPerYear: [
          { required: true, validator: installmentPerYearValidator, trigger: 'blur' }
        ],
        afterYearsPayNextPrice: [
          { required: true,  validator: afterYearsPayNextPriceValidator, trigger: 'change' }
        ],
        installmentPerYearPriceAddPercent: [
          { required: true, validator: installmentPerYearPriceAddPercentValidator, trigger: 'blur' }
        ]
      },
      dialogFormVisible: false,
      createContractInfo: {
        // projectAssets: {}
      },
      disputeWay: null, // 争议解决途径
      contractPeriod: null, // 承包期限
      previewContract: null, // 预览合同的信息
      massifType: null // 地块类型
    };
  },
  created() {
    this.ruleForm.userId = this.$route.query.userId;
    this.ruleForm.projectId = this.$route.query.id;
    this.ruleForm.projectType = this.$route.query.projectType;
    this.projectSubType = this.$route.query.projectSubType;
    this.getDictList();
  },
  watch: {
    'ruleForm.installmentPriceOfFirst'(newName, oldName) {
      if(newName !== oldName) {
        this.ruleForm.remainingPriceOfFirstInstallment = this.ruleForm.installmentPriceOfFirst - (this.createContractInfo.marginSubServiceFee);
      }
    }
  },
  mounted() {
    this.getContractData();
  },
  methods: {
    installmentPriceValidator(rule, value, callback) {
      if (value === '' || value === null) {
        return callback(new Error('请输入价款金额'));
      } else if (value < 1 || value > 999999999) {
        return callback(new Error('请输入1-999999999的金额'));
      } else {
        return callback();
      }
    },
    installmentPriceOfFirstValidator(rule, value, callback) {
      if (value === '') {
        return callback(new Error('请输入第一期价款金额'));
      } else if(value < this.createContractInfo.marginSubServiceFee){
        return callback(new Error('不能小于竞价保证金-服务费'));
      } else {
        callback();
      }
    },
    payDateValidator(rule, value, callback) {
      if (!value) {
        return callback(new Error('请选择最晚支付日期'));
      } else {
        callback();
      }
    },
    validateSumPrice() {
      // 农机设备转让并且是分期支付
      if (Number(this.projectSubType) === 1 && Number(this.ruleForm.payType) === 2) {
        let sumNum = Number(this.ruleForm.installmentPriceOfFirst);
        this.ruleForm.installmentPriceOfFirstExList.map(item => {
          sumNum += Number(item.amount);
        });
        // 分期总金额 等于成交总金额
        if(sumNum === Number(this.ruleForm.sumCurrentPrice)) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    // 添加或者删除的时候
    handleChange(type) {
      console.log(this.ruleForm.installmentSumTerm, 'event');
      if(type === 1) {
        this.ruleForm.installmentSumTerm --;
        if(this.ruleForm.installmentSumTerm < 2){
          this.ruleForm.installmentSumTerm = 2;
          return;
        }
        // 删除最后一个对象
        this.ruleForm.installmentPriceOfFirstExList.pop();
      } else {
        this.ruleForm.installmentSumTerm ++;
        if(this.ruleForm.installmentSumTerm > 10){
          this.ruleForm.installmentSumTerm = 10;
          return;
        }
        // 在最后面追加
        this.ruleForm.installmentPriceOfFirstExList.push({
          amount: '',
          payDate: ''
        });
      }
    },
    change(){
      this.$forceUpdate();
    },
    // 获取用户类型 字典查询
    getDictList () {
      const obj = {
        DISPUTE_RESOLUTION_WAY: 'disputeWay',
        CONTRACT_PERIOD: 'contractPeriod',
        MASSIF_TYPE: 'massifType'
      };
      Object.keys(obj).forEach((key) => {
        Service.getSelectList(key).then(res => {
          if (res && res.code === '0') {
            this[obj[key]] = res.data;
          }
        });
      });
    },
    // 数据回显
    getContractData() {
      ProjectService.toCreateContract(this.ruleForm.projectId, this.ruleForm.userId, this.ruleForm.projectType).then(res => {
        if (res && res.code === '0') {
          // this.createContractInfo = res.data;
          this.createContractInfo = {
            ...res.data
            // projectAssets: res.data.projectAssets.map(item => ({
            //   ...item,
            //   assetsInfo: JSON.parse(item.assetsInfo)
            // }))
          };
          for (let key in this.createContractInfo) {

            // 第一期价款金额如果小于0 则等于0
            if(res.data.installmentPriceOfFirst < 0) {
              this.createContractInfo.installmentPriceOfFirst = 0;
            } else if(key === 'disputeResolutionWay') {
              if(this.ruleForm.disputeResolutionWay) {
                this.ruleForm.disputeResolutionWay = this.ruleForm.disputeResolutionWay && this.ruleForm.disputeResolutionWay.toString();
              } else {
                this.ruleForm.disputeResolutionWay = '1';
              }
            } else if(key === 'remainingPriceOfFirstInstallment') {
              if(!res.data.remainingPriceOfFirstInstallment) {
                this.ruleForm.remainingPriceOfFirstInstallment = this.createContractInfo.installmentPriceOfFirst - this.createContractInfo.marginSubServiceFee;
              }
            } else if (key === 'installmentSumTerm' && !this.createContractInfo.installmentSumTerm) {
              // 至少两期
              this.ruleForm.installmentSumTerm = 2;
            } else if (key === 'installmentPriceOfFirstExList' && !this.createContractInfo.installmentPriceOfFirstExList) {
            } else if(key === 'resolveDisputesWays' && res.data.resolveDisputesWays) { // 其他途径复选
              this.ruleForm.resolveDisputesWays = String(this.ruleForm.resolveDisputesWays);
              this.checked1 = true;
            } else {
              if (this.ruleForm.hasOwnProperty(key)) {
                this.ruleForm[key] = this.createContractInfo[key];
              }
            }

          }
        }
      });
    },
    previousStep () {
      this.$router.back();
    },
    // 预览合同
    previewBtn() {
      if(this.validateSumPrice()) {
        errorMessage('分期金额之和必须等于成交价金额，请确认');
        return;
      }
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = true;
          this.submit(false);
        } else {
          return false;
        }
      });
    },
    // 立即提交
    test() {
      if(this.validateSumPrice()) {
        errorMessage('分期金额之和必须等于成交价金额，请确认');
        return;
      }
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交合同信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit(true);
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },
    // 确认提交按钮
    submit(isSave) {
      // 保存接口传参
      ProjectService.createContract({
        isSave: isSave,
        ...this.ruleForm
      }).then(res => {
        if(isSave) {
          if (res && res.code === '0') {
            successMessage('创建成功');
            this.$router.push('/person-center/project/roll-out-project/list');
          } else if (res && res.reason) {
            errorMessage(res && res.reason);
          } else {
            errorMessage('创建失败');
          }
        } else {
          ProjectService.displayWoodsContract(
            this.ruleForm.projectId,
            this.ruleForm.projectType,
            this.ruleForm.userId,
            '1'
          ).then(res => {
            if (res && res.code === '0') {
              this.previewContract = res.data;
              // this.getContractData();
            }
          });
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('创建失败');
        }
      });
    }
  }
};
